app.controller('templateCreatePopupController', ['$scope', '$mdDialog', '$injector', 'objectHelper', 'templateModel', 'visitCard',
    function ($scope, $mdDialog, $injector, objectHelper, templateModel, visitCard) {

        function setData() {
            $scope.visitCard = visitCard;
            $scope.template = {
                name: null
            }
        }

        function setPermissions() {
        }

        function setListeners() {
        }

        function setActions() {
            $scope.ok = function () {
                if($scope.template.name) {
                    $scope.savingInProgress = true;
                    templateModel.saveFromVisitCard($scope.visitCard.id, $scope.template).then(function (newTemplate) {
                        $scope.savingInProgress = false;
                    }, function () {
                        $scope.savingInProgress = false;
                    });
                    $mdDialog.hide();
                }
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }

        function configureInterface() {
        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);

